<template>
  <div class="container-fluid">
    <div class="card border-0">
      <div class="card-body">
        <h5 class="card-title">
          <div class="company">{{ companyName }}</div>
          <div class="time">{{ timeFrame }}</div>
        </h5>
        <br>
        <h6 class="card-subtitle mb-2 text-muted">
          <div class="position">{{ position }}</div>
          <div class="location">{{ location }}</div>
        </h6>
        <br>
        <ul>
          <li v-for="(description, index) in descriptions" :key="index">{{ description }}</li>
        </ul>
        <br>
        <div class="skill">
          <b-badge
            pill
            variant="secondary"
            v-for="(skill, index) in skills"
            :key="index"
          >{{ skill }}</b-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Work",
  props: ["companyInfo"],
  data() {
    return {
      companyName: this.companyInfo.companyName,
      position: this.companyInfo.position,
      timeFrame: this.companyInfo.timeFrame,
      descriptions: this.companyInfo.dutiesAndResponsibilities,
      skills: this.companyInfo.skills,
      location: this.companyInfo.location
    };
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Catamaran|Martel+Sans");

.company {
  font-weight: bold;
  display: block;
  color: #f05e25;
  margin: 0;
  float: left;
  font-size: 1.2em;
  clear: both;
}
.time {
  float: right;
  font-size: 0.9em;
  font-family: "Catamaran", sans-serif;
}
.location {
  float: right;
  font-size: 0.9em;
  color: #4a4a4a;
  overflow: hidden;
  font-weight: normal;
  font-family: "Catamaran", sans-serif;
}
.position {
  float: left;
  font-size: 0.9em;
  color: #000;
  font-weight: 550;
  font-family: "Catamaran", sans-serif;
  clear: both;
}
li {
  font-size: 0.8em;
  float: left;
  clear: both;
  text-align: left;
}
li:before {
  content: "\25b8 ";
}
.skill {
  float: left;
  clear: both;
  margin-top: 5px;
}
.skill > * {
  margin-right: 8px;
}
.container-fluid {
  margin-bottom: 10px;
  padding: 0;
}
</style>
